import FitoImage from "../molecules/fito-image.molecule";
import TextBubble from "../molecules/text-bubble.molecule";
import CustomText from "../atoms/custom-text.atom";

const FitoWithBubble = ({ text = "Te tomará 5 minutos", emotion = "half-happy" }) => (
  <div style={{ position: "relative", width: 360, height: 200 }}>
    <FitoImage
      emotion={emotion}
      style={{ width: 112, height: 112, position: "absolute", left: 127, top: 69 }}
    />
    <TextBubble
      text={
        <CustomText
          variant="body"
          style={{
            transform: "rotate(10.755deg)",
            whiteSpace: "normal",
            textAlign: "center",
            maxWidth: 101,
          }}
        >
          {text}
        </CustomText>
      }
      style={{ position: "absolute", left: 196, top: 0 }}
    />
  </div>
);

export default FitoWithBubble;
